import React from 'react';

import {
  ReferenceArrayInput,
  required,
  SelectArrayInput,
  SelectInput,
} from 'react-admin';

import { Box } from '@mui/material';

import { capitalize } from 'lodash';

import entityTypes from '../../../../constants/entityTypes';
import SmartDateInput from '../../../../customFields/SmartDateInput';
import isPastDate from '../../../utils/reports/isPastDate';
import { strictDateRangeValidation } from '../../../utils/reports/dateRangeValidation';
import nonEmptySelection from '../../../utils/reports/nonEmptySelection';
import currencies from '../../../../constants/currencies';
import FieldBox from '../FieldBox';
import RangeFields from '../RangeFields';

const EntityTransactions = () => (
  <Box display="flex" flexDirection="column" gap={4}>
    <FieldBox title="Date range" description="Only transactions within this date range are included. Both dates are required.">
      <RangeFields
        from={(
          <SmartDateInput fullWidth validate={[required(), isPastDate, strictDateRangeValidation]} source="report.from" label="From *" helperText={false} />
        )}
        to={(
          <SmartDateInput fullWidth validate={[required(), isPastDate, strictDateRangeValidation]} source="report.to" label="To *" helperText={false} />
        )}
      />
    </FieldBox>
    <FieldBox title="Currency *" description="Only transactions in this currency are included in the analysis. Required.">
      <SelectInput
        choices={currencies.map((currency) => ({
          name: currency,
          id: currency,
        }))}
        fullWidth
        label=""
        source="report.currency"
        validate={required()}
        helperText={false}
      />
    </FieldBox>
    <FieldBox title="Entity type *" description="Only transactions for entities of this type are included. Required.">
      <SelectInput
        choices={Object.values(entityTypes).map(
          (status) => ({ id: status, name: capitalize(status) }),
        )}
        fullWidth
        label=""
        source="report.entityType"
        validate={required()}
        helperText={false}
      />
    </FieldBox>
    <FieldBox title="Groups" description="Only transactions for entities in at least one of these groups are included. Leave untouched to include all entities regardless of group membership.">
      <ReferenceArrayInput
        source="report.groupIds"
        reference="groups"
        perPage={200}
        label="groups"
        filter={{ active: true }}
      >
        <SelectArrayInput label="" helperText={false} validate={[nonEmptySelection]} />
      </ReferenceArrayInput>
    </FieldBox>
  </Box>
);

export default EntityTransactions;
